import { render, staticRenderFns } from "./GameMaterialModal.vue?vue&type=template&id=7945326f&scoped=true&"
import script from "./GameMaterialModal.vue?vue&type=script&lang=ts&"
export * from "./GameMaterialModal.vue?vue&type=script&lang=ts&"
import style0 from "./GameMaterialModal.vue?vue&type=style&index=0&id=7945326f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7945326f",
  null
  
)

export default component.exports